import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { API } from '../API';
import { SearchParams } from '../SearchParams';
import { DIALOG_TYPES } from './ModalDialog';

const _api = Symbol();

class ResetPassword extends BaseElement {
	constructor() {
		super();

		this.library.add(faCheck);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					
				}
				
				.centered {
					display: flex;
					justify-content: center;
				}
				input {
					margin: 0 0.25em 0.25em 0;
				}
				a:before {

				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api = null;
	}
	async handleSubmit(e) {
		try {
			e.preventDefault();
			if(!this.api)
				throw new Error('api property not set!');
			
			const { token } = SearchParams.fromString(window.location.search).toJSON();
			const { password, confirm } = Object.fromEntries(new FormData(e.target));
			e.target.reset();
			
			if(!password)
				throw new Error('No password entered. Please enter a new account password.');
			if(password !== confirm)
				throw new Error('Password and confirm do not match. Please try again.');
			
			this.emit('show-dialog', {
				title: 'Password Reset Request',
				message: await this.api.passwordReset(token, password),
				type: DIALOG_TYPES.DIALOG_TYPE_INFO
			});
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Auth Service Error',
				message: err instanceof TypeError ? 'Failed to connect to authentication service.' : err.message,
				type: DIALOG_TYPES.DIALOG_TYPE_ERROR
			});
		}
	}
	render() {
		return html`
			<h4>Account password reset</h4>
			<p>
				Please enter your and confirm your new password.
			</p>
			<div class="centered">
				<form @submit="${e => this.handleSubmit(e)}">
					<input type="password" name="password" placeholder="Passowrd" name=""/>
					<input type="password" name="confirm" placeholder="Confirm" name=""/>
					<button type="submit">
						<i class="icon fas fa-check"></i>
						Submit
					</button>
				</form>
			</div>
		`;
	}
}

customElements.define('pp-reset-password', ResetPassword);